import { login, logout } from '@/api/auth'
import { update } from '@/api/user'
import { subscribe, unsubscribe } from '@/api/messaging'
import Vue from 'vue'

const defaultUser = {
  id: null,
  role_id: null,
  role_name: null,
  username: null,
  email: null,
  last_login: null,
  avatar: null,
  gateways: [],
  permissions: []
}

const defaultPref = {
  font_size: 'medium',
  landing_page: 'dashboard',
  is_notify_alarm: true,
  is_notify_trouble: false,
  is_notify_email: false,
  is_notify_whatsapp: false
}

export default {
  namespaced: true,
  state: {
    user: defaultUser,
    preferences: defaultPref
  },
  getters: {
    isLoggedIn(state) {
      return !!state.user.username
    },
    hasPermission(state) {
      return (module, method) => {
        const found = state.user.permissions.find(item => {
          if (Array.isArray(method)) {
            return item.module === module && method.includes(item.method)
          }
          return item.module === module && item.method === method
        })
        return !!found
      }
    }
  },
  mutations: {
    clearUser(state) {
      state.user = defaultUser
    },
    setUser(state, payload) {
      state.user = {
        id: payload.id,
        role_id: payload.role.id,
        role_name: payload.role.name,
        username: payload.username,
        email: payload.email,
        last_login: payload.last_login,
        avatar: payload.avatar,
        gateways: payload.gateways,
        permissions: payload.role.permissions
      }
    },
    setPreferences(state, payload) {
      document.documentElement.classList.remove(`has-font-${state.preferences.font_size}`)
      state.preferences = payload
      document.documentElement.classList.add(`has-font-${payload.font_size}`)
    }
  },
  actions: {
    setPref({ commit, state }, payload) {
      const {
        font_size,
        landing_page,
        is_notify_alarm,
        is_notify_trouble,
        is_notify_email,
        is_notify_whatsapp
      } = payload

      return update({
        id: state.user.id,
        font_size,
        landing_page,
        is_notify_alarm,
        is_notify_trouble,
        is_notify_email,
        is_notify_whatsapp
      })
        .then(res => {
          commit('setPreferences', {
            font_size,
            landing_page,
            is_notify_alarm,
            is_notify_trouble,
            is_notify_email,
            is_notify_whatsapp
          })
          Vue.prototype.$messaging.getToken().then((token) => {
            subscribe({ token })
          })
          return res
        })
    },
    login({ commit }, payload) {
      const { username, password } = payload

      return login({
        username: username,
        password: password,
      })
        .then(res => {
          commit('setUser', res.data)
          return res
        })
    },
    async logout({ commit }) {
      commit('clearUser')
      try {
        await unsubscribe()
        await logout()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
